import React from "react";

function FilterTypeWrap(props: any) {
  const { children } = props;
  return <div style={{ marginBottom: "25px" }}>{children}</div>;
}

export default FilterTypeWrap;
